import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import {
    IContextService, DomainContext,
    PershingTranslationService
} from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-vot-summary',
    templateUrl: './dojo-vot-summary.component.html'
})
export class DojoVotSummaryComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    votDownloadLinkParams: any;
    isAdaTheme: boolean = false;
    title: string;
    ismobile: boolean = false;
    bankCustodyAccount: boolean = false;

    constructor(
        private contextService: IContextService,
        private translationService: PershingTranslationService,
        private nxiRestService: NxiRestService,
        private nxiWidgetParamsService: NxiWidgetParamsService,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
            this.title = 'dojo-vot-summary';
        }
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.ismobile = true;
        }
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;

            this.renderDojoWidget();
        });
    }

    ngOnDestroy(): void {
        console.log('In dojo valuation Summary destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyVotSummary();
        }
    }
    renderDojoWidget() {
        if (dojoApp && this.acctRef) {
            // pass necessary parameters to render dojo widgets
            let votSummaryRESTUrl = this.nxiRestService.serviceUrl + '/portfolio/' + this.acctRef + '/valuation-over-time';
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'valuationOverTimeLinkData').subscribe(
                resp => {
                    if (resp.response) {
                        resp.response.downloadUrl = this.nxiRestService.serviceUrl + resp.response.downloadUrl;
                        this.votDownloadLinkParams = resp.response;
                        this.bankCustodyAccount = resp.response.bankCustodyAccount ? resp.response.bankCustodyAccount : false;
                        dojoApp.renderVotSummary(this.acctRef, votSummaryRESTUrl, this.votDownloadLinkParams);
                    }
                }
            );

        }
    }

}
